module.exports = __webpack_public_path__ + "static/media/share.87b02c34.svg";